import React from 'react';
import type { LinkProps } from 'react-router-dom';
import { Link } from 'react-router-dom';

export const ReactRouterMUILink = React.forwardRef<
  HTMLAnchorElement,
  Omit<LinkProps, 'to'> & { href: LinkProps['to'] }
>((props, ref) => {
  const { href, ...other } = props;

  if (typeof href === 'string' && /^https?:\/\//i.test(href)) {
    return <a ref={ref} href={href} {...other} />;
  }

  return <Link ref={ref} to={href} {...other} />;
});
